(ns practitest.frontend.tests.test-form.test-steps
  (:require [clojure.set]
            [clojure.string :as str]
            [practitest.frontend.common.ai-text-enhancement :as ai-text-enhancement]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.common.i18n :refer [format-translation
                                                     get-translation]]
            [practitest.frontend.common.re-frame :refer [partial-dispatch]]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.components.attachments3 :as attachments]
            [practitest.frontend.components.comments3 :as comments]
            [practitest.frontend.components.grid.columns-settings :as oldsettings]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.markdown3 :as markdown3]
            [practitest.frontend.components.overlay2 :as overlay2]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.entity-form :as entity-form]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.dndkit :as dndkit]
            [practitest.frontend.components2.dropdown :as dropdown]
            [practitest.frontend.components2.entity-form.forms :as forms]
            [practitest.frontend.components2.grid :as grid2]
            [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.forms3.entity-form.forms :as f3.forms]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.tests.events :as tests-events]
            [practitest.frontend.tests.test-form.call-to-test :as call-to-test]
            [practitest.frontend.tests.test-form.smartfox-modal :as smartfox-modal]
            [practitest.frontend.tests.test-form.common :refer [get-last-position
                                                                init-step-form-object
                                                                insert-steps-at
                                                                random-step-id
                                                                steps-form-id]]
            [practitest.frontend.tests.test-form.copy-steps :as copy-steps]
            [practitest.frontend.common.keyboard-shortcuts :as keyboard-shortcuts]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

;;; Helpers

;; TODO: better internal representation to simplify this ?
(defn- update-in-step
  [steps step-id step-fn]
  (mapv
    (fn [step]
      (if (= (:id step) step-id)
        (step-fn step)
        step))
    steps))

(defn- on-drop-attachments
  [e entity-id entity-type upload-event upload-failed-event new-step?]
  (let [dt (.-dataTransfer e)
        files (.-files dt)]
    (when (pos? (.-length files))
      (let [file (aget files 0)]
        (if new-step?
          (re-frame/dispatch [::attachments/stage-upload file {:entity-type entity-type
                                                               :uploaded-attachment-event upload-event
                                                               :uploaded-attachment-failed-event upload-failed-event}])
          (re-frame/dispatch
            [::attachments/upload
             file
             {:entity-id entity-id
              :entity-type entity-type
              :uploaded-attachment-event upload-event
              :uploaded-attachment-failed-event upload-failed-event
              :renamed-attachment-event [::attachments/renamed]
              :deleted-attachment-event [::attachments/deleted]}]))))
    (.preventDefault e)
    (.stopPropagation e)))

(defn- on-drag-over-attachments [e]
  (when (some? (some-> e .-dataTransfer .-types (js/Array.prototype.includes.call "Files")))
    (.preventDefault e)
      (.stopPropagation e)))

(defn- on-load-attachments [file
                            entity-id
                            entity-type
                            attachments
                            max-attachments
                            max-attachment-size
                            uploaded-attachment-event
                            uploaded-attachment-failed-event
                            renamed-attachment-event
                            deleted-attachment-event
                            new-step?]
       (attachments/check-file-and-upload
         {:file                file
          :attachments         attachments
          :max-attachments     max-attachments
          :max-attachment-size max-attachment-size
          :on-upload           (fn [file]
                                 (if new-step?
                                   (re-frame/dispatch
                                     [::attachments/stage-upload
                                      file
                                      {:entity-type                      entity-type
                                       :uploaded-attachment-event        uploaded-attachment-event
                                       :uploaded-attachment-failed-event uploaded-attachment-failed-event}])
                                   (re-frame/dispatch
                                     [::attachments/upload
                                      file
                                      {:entity-id                        entity-id
                                       :entity-type                      entity-type
                                       :uploaded-attachment-event        uploaded-attachment-event
                                       :uploaded-attachment-failed-event uploaded-attachment-failed-event
                                       :renamed-attachment-event         renamed-attachment-event
                                       :deleted-attachment-event         deleted-attachment-event}])))
          ;In case of error during file uploading - show notifications
          :on-error            (fn [message]
                                 (re-frame/dispatch [::notifications/error2 message {:raw-html? true :auto-close true}])
                                 (re-frame/dispatch uploaded-attachment-failed-event))}))

(defn init-steps-form-state [db test steps dirty?]
  (if (or (nil? test)
          (nil? steps))
    db
    (assoc-in db
              [:form-states2 steps-form-id]
              {:fields {:preconditions {:value (:preconditions test)}}
               :preconditions? (some? (:preconditions test))
               :steps (into {}
                            (map (fn [step]
                                   [(:id step) (init-step-form-object (:id step) (:position step) dirty? step)]))
                            steps)
               :steps-params (re-frame/dispatch [::tests-events/fetch-steps-params])})))

;; Function to build rails-compatible representation to be sent to server
(defn- build-rails-object-from-state
  [db new?]
  (let [form-state (get-in db [:form-states2 steps-form-id])
        preconditions (get-in form-state [:fields :preconditions])
        precondition-stage-attachments (:precondition-stage-attachments form-state)
        result {}
        steps (vals (:steps form-state))]
    (-> result
         ;; Preconditions - only include if preconditions? is true
        (cond-> (:dirty? preconditions)
          (assoc-in [:qtest_design :preconditions] (:value preconditions)))
        ;; Precondition staged attachments (for new tests)
        (cond-> (seq precondition-stage-attachments)
          (assoc-in [:qtest_design :precondition_stage_attachments]
                    (into {} (map (fn [a] [(:id a) (:name a)]) precondition-stage-attachments))))
        ;; Deleted steps
        ; qtest_design[steps][deleted] - comma-separated list of deleted steps
        (assoc-in [:qtest_design :steps :deleted] (str/join "," (:steps-to-remove form-state)))
        ;; New steps:
        ;qtest_design[steps][new][][name]: New Step 2
        ;qtest_design[steps][new][][description]: asd
        ;qtest_design[steps][new][][expected_results]: asd
        ;qtest_design[steps][new][][test_to_call_id]:
        ;qtest_design[steps][new][][tmp_id]: 17391616777507492
        (assoc-in (if new?
                    [:qtest_design :new_step_containers_attributes]
                    [:qtest_design :steps :new])
                  (->> steps
                       (sort-by :position)
                       (filter :new?)
                       (mapv
                     (fn [step]
                       (let [name (get-in step [:fields :name :value])
                             description (get-in step [:fields :description :value])
                             expected-results (get-in step [:fields :expected_results :value])
                             copied-from-test (get-in step [:fields :copied_from_test])
                             copied-from-step (get-in step [:fields :copied_from_step])
                             type (:type step)
                             callee-test-id (:id (:callee-test step))
                             tmp-id (str (:id step))
                             stage-attachments (get-in step [:attachments :stage])]
                         (cond-> {}
                           (= type :step)
                           (assoc :name name
                                  :description description
                                  :expected_results expected-results)
                           (= type :call-to-test)
                           (assoc :test_to_call_id callee-test-id)
                           copied-from-test
                           (assoc :copied_from_test copied-from-test)
                           copied-from-step
                           (assoc :copied_from_step copied-from-step)
                           
                           (not new?)
                           (assoc :tmp_id tmp-id)
                           (seq stage-attachments)
                           (assoc :stage_attachments (into {} (map (fn [a] [(:id a) (:name a)]) stage-attachments)))))))))
        ;; Updated existing steps:
        ;qtest_design[steps][update][285750][name]: Test 3 Step 1
        ;qtest_design[steps][update][285750][description]: Test 3 Step 1 Description
        ;qtest_design[steps][update][285750][expected_results]: Test 3 Step 1 Expecte resultasdadaasd
        (assoc-in [:qtest_design :steps :update]
                  (into {}
                        (map
                          (fn [step]
                            [(:id step)
                             {:name (get-in step [:fields :name :value])
                              :description (get-in step [:fields :description :value])
                              :expected_results (get-in step [:fields :expected_results :value])}]))
                        ;; Updated step will have dirty fields
                        (remove :new? (filter #(some :dirty? (vals (:fields %))) steps))))
        ;; Ordering - only for edit mode
        ; qtest_design[steps][positions] - 285750,17391616777507492,285751,285752 - comma-separated of steps positions (with tempids)
        (cond-> (not new?)
          (assoc-in [:qtest_design :steps :positions] (str/join "," (map :id (sort-by :position steps))))))))

(defn merge-into-steps
  [new? db form-params]
  (let [steps-part (build-rails-object-from-state db new?)]
    ;; Merge steps and existing form state together
    (merge-with merge form-params steps-part)))

;;; Subscriptions

(defn get-step-field-state [db step-id] (get-in db [:form-states2 steps-form-id :steps step-id]))

(re-frame/reg-sub
  ::step-field-state
  (fn [db [_ step-id]] (get-step-field-state db step-id)))

(re-frame/reg-sub
  ::step-comments
  (fn [db [_ step-id]]
    (let [steps-data (get-in db [:entity :test :steps])]
      (:comments (first (filter #(= step-id (:id %)) steps-data))))))

(re-frame/reg-sub
 ::step-attachments
 (fn [db [_ step-id]]
   (let [steps-data (get-in db [:entity :test :steps])
         form-step (get-in db [:form-states2 steps-form-id :steps step-id])
         backend-step (first (filter #(= step-id (:id %)) steps-data))
         new-step? (:new? form-step)
         attachments (if new-step?
                       (get-in form-step [:attachments :stage])
                       (:attachments backend-step))]
     (when (seq attachments)
       (if new-step?
         attachments
         (map attachments/process-backend-attachment-data attachments))))))

(re-frame/reg-sub
  ::show-preconditions?
  (fn [db]
    (get-in db [:form-states2 steps-form-id :preconditions?])))

(re-frame/reg-sub
  ::new-precondition?
  (fn [db]
    (get-in db [:form-states2 steps-form-id :new-precondition?])))

(re-frame/reg-sub
 ::is-preconditions-linked-to-test?
 (fn [db]
   (contains? (get-in db [:entity-fields :test]) :preconditions)))

;;; Event handlers
(re-frame/reg-event-fx
  ::scroll-to-new-step
  (fn [_ [_ step-id]]
    (reagent/after-render
      (fn []
        ;; TODO: keep consistent with styles or switch to refs
        (when-let [container (js/document.querySelector (str "div[data-step-id=\"" step-id "\"]"))]
          (dom/scroll-if-needed container)
          (some-> (.querySelector container "textarea.step-name-editor") (.focus)))))
    {}))

(re-frame/reg-event-fx
  ::add-empty-step
  (fn [{db :db} [_ add-position]]
    (let [id (random-step-id)]
      {:db (-> db
               (update-in [:form-states2 steps-form-id :steps]
                          (fn [steps]
                            (let [add-position (or add-position
                                                   (get-last-position steps))
                                  new-step {:id id
                                            :type :step
                                            :new? true
                                            :fields {}
                                            :attachments {:stage []}}]
                              (insert-steps-at steps [new-step] add-position))))
               (assoc-in [:form-states2 steps-form-id :dirty?] true))
       :dispatch [::scroll-to-new-step id]})))

(re-frame/reg-event-fx
  ::focus-on-preconditions
  (fn []
    (reagent/after-render
      ;; TODO: keep consistent with styles or switch to refs
      #(some-> (js/document.querySelector "textarea#preconditions") (.focus)))
    {}))

(re-frame/reg-event-fx
  ::add-preconditions
  (fn [{db :db}]
    {:db (-> db
             (assoc-in [:form-states2 steps-form-id :dirty?] true)
             (assoc-in [:form-states2 steps-form-id :preconditions?] true)
             (assoc-in [:form-states2 steps-form-id :new-precondition?] true)
             (assoc-in [:form-states2 steps-form-id :fields :preconditions]
                       {:value "" :dirty? true :new? true}))
     :dispatch [::focus-on-preconditions]}))

(defn build-steps-vec
  [new-steps]
  (map-indexed
    (fn [idx step]
      (assoc step :id (random-step-id)
             :position (inc idx)
             :type :step
             :new? true
             :fields {}))
    new-steps))

(re-frame/reg-event-db
  ::add-steps-from-et
  (fn [db [_ response]]
    (let [new-steps (:steps response)
          new-steps-vec (build-steps-vec new-steps)]
      (-> (init-steps-form-state db (:entity response) new-steps-vec true)
          (assoc-in [:form-states2 steps-form-id :dirty?] true)))))

(re-frame/reg-event-db
  ::change-step-field-value
  (fn [db [_ step-id field-id value]]
    (update-in db [:form-states2 steps-form-id :steps step-id :fields field-id]
               assoc :value value :dirty? true)))

(re-frame/reg-event-db
  ::remove-step
  (fn [db [_ step-form-state]]
    (let [step-id (:id step-form-state)
          new? (:new? step-form-state)]
      (-> db
          (update-in [:form-states2 steps-form-id :steps] dissoc step-id)
          ;; Recalculate positions
          (update-in [:form-states2 steps-form-id :steps]
                     (fn [steps]
                       (reduce
                         (fn [steps [idx step-id]]
                           (assoc-in steps [step-id :position] (inc idx)))
                         steps
                         (map-indexed (fn [idx step]
                                        [idx (:id step)])
                                      (sort-by :position (vals steps))))))
          ;; Mark form as dirty
          (assoc-in [:form-states2 steps-form-id :fields :steps :dirty?] true)
          ;; Save steps to remove
          (update-in [:form-states2 steps-form-id :steps-to-remove]
                     (fn [steps-to-remove]
                       (if new?
                         ;; No need to send removed unsaved steps to server
                         steps-to-remove
                         ((fnil conj #{}) steps-to-remove step-id))))))))

(re-frame/reg-event-db
  ::step-attachment-uploaded
  (fn [db [_ step-id file upload-id upload-options result]]
    (if (= (:result result) "ok")
      (update-in db [:entity :test :steps]
                 update-in-step step-id
                 (fn [step]
                   (update step :attachments (fnil conj []) (first (:data result)))))
      db)))

(defn- remove-file-placeholder [db step-id field-id value file-placeholder]
  (update-in db [:form-states2 steps-form-id :steps step-id :fields field-id]
             assoc :value (str/replace value file-placeholder "") :dirty? true))

(re-frame/reg-event-fx
  ::step-attachment-uploaded-from-markdown
  (fn [{db :db} [_ step-id field-id file-placeholder _ _ _ result]]
    {:db (let [value (get-in (get-step-field-state db step-id) [:fields field-id :value])
               attachment (first (:data result))
               attachment-url  (attachments/generate-attachment-url {:url  (:url attachment)
                                                                     :name (:name attachment)
                                                                     :type (:file_type attachment)})
               new-value (if file-placeholder
                           (str/replace value file-placeholder attachment-url)
                           (str value "\n" attachment-url))]
           (if (= (:result result) "ok")
             (-> db
                 (update-in [:entity :test :steps]
                            update-in-step step-id (fn [step]
                                                     (update step :attachments (fnil conj []) attachment)))
                 (update-in [:form-states2 steps-form-id :steps step-id :fields field-id]
                            assoc :value new-value :dirty? true))
             (remove-file-placeholder db step-id field-id value file-placeholder)))}))

(re-frame/reg-event-fx
  ::precondition-attachment-uploaded-from-markdown
  (fn [{db :db} [_ file-placeholder _ _ _ result]]
    (let [field-state (get-in db [:form-states2 steps-form-id :fields :preconditions :value])
          attachment (first (:data result))
          attachment-url (attachments/generate-attachment-url {:url  (:url attachment)
                                                               :name (:name attachment)
                                                               :type (:file_type attachment)})
          new-value (if file-placeholder
                      (str/replace field-state file-placeholder attachment-url)
                      (str field-state "\n" attachment-url))]
      {:db (assoc-in db
                     [:form-states2 steps-form-id :fields :preconditions]
                     {:value new-value
                      :dirty? true})})))

(re-frame/reg-event-fx
  ::precondition-attachment-upload-failed-from-markdown
  (fn [{db :db} [_ file-placeholder]]
    (let [field-state (get-in db [::entity-form/forms steps-form-id :fields :preconditions :value])
          current-value (or (:value field-state) "")
          new-value (str/replace current-value file-placeholder "")]
      {:db (assoc-in db
                     [::entity-form/forms steps-form-id :fields :preconditions]
                     {:value new-value})})))

;; Unified event for handling staged attachments from markdown (steps and preconditions)
(re-frame/reg-event-fx
  ::attachment-staged-from-markdown
  (fn [{db :db} [_ {:keys [stage-path field-path]} file-placeholder file upload-id upload-options stage-data]]
    (if stage-data
      (let [value (get-in db (conj field-path :value))
            attachment-url (attachments/generate-attachment-url {:url  (:url stage-data)
                                                                  :name (:name stage-data)
                                                                  :type (:type stage-data)})
            new-value (if file-placeholder
                        (str/replace value file-placeholder attachment-url)
                        (str value "\n" attachment-url))]
        {:db (-> db
                 (update-in stage-path (fnil conj []) stage-data)
                 (assoc-in field-path {:value new-value :dirty? true}))})
      {})))

(re-frame/reg-event-fx
  ::step-attachment-uploaded-failed-from-markdown
  (fn [{db :db} [_ step-id field-id file-placeholder]]
    {:db (let [value (get-in (get-step-field-state db step-id) [:fields field-id :value])]
           (remove-file-placeholder db step-id field-id value file-placeholder))}))

(re-frame/reg-event-db
  ::step-attachment-deleted
  (fn [db [_ step-id attachment delete-options result]]
    (update-in db [:entity :test :steps]
               update-in-step step-id
               (fn [step]
                 (update step :attachments
                         (fn [attachments]
                           (remove #(= (:id %) (:id attachment)) attachments)))))))

(re-frame/reg-event-db
  ::step-attachment-staged
  (fn [db [_ step-id file upload-id upload-options stage-data]]
    (if stage-data
      (update-in db [:form-states2 steps-form-id :steps step-id :attachments :stage]
                 (fnil conj []) stage-data)
      db)))


(re-frame/reg-event-db
  ::step-attachment-stage-deleted
  (fn [db [_ step-id attachment]]
    (if (nil? attachment)
      db
      (update-in db [:form-states2 steps-form-id :steps step-id :attachments :stage]
                 (fn [attachments]
                   (vec (remove #(= (:id %) (:id attachment)) attachments)))))))

(re-frame/reg-event-db
  ::step-attachment-renamed
  (fn [db [_ step-id attachment rename-options result]]
    (update-in db [:entity :test :steps]
               update-in-step step-id
               (fn [step]
                 (update step :attachments
                         (fn [attachments]
                           ;; In rename we get only one item in `data` field
                           (mapv #(if (= (:id %) (:id attachment)) (:data result) %)
                                 attachments)))))))

(re-frame/reg-event-fx
  ::added-comment
  (fn [{db :db} [_ test-id {:keys [entity-id]} response]]
    ;; Response will have new set of comments here
    {:db (update-in db
                    [:entity :test :steps]
                    update-in-step entity-id
                    #(assoc % :comments (:body response)))}))

(re-frame/reg-event-db
  ::remove-preconditions
  (fn [db]
    (-> db
        (assoc-in [:form-states2 steps-form-id :preconditions?] false)
        (assoc-in [:form-states2 steps-form-id :dirty?] true)
        (assoc-in [:form-states2 steps-form-id :fields :preconditions] {:value nil :dirty? true}))))

(re-frame/reg-event-db
  ::reorder-steps
  (fn [db [_ new-vector-of-steps]]
    (-> db
        (update-in [:form-states2 steps-form-id :steps]
                   (fn [steps]
                     (reduce
                       (fn [steps step]
                     ;; update positions inside form state
                         (assoc-in steps [(:id step) :position] (:position step)))
                       steps
                       new-vector-of-steps)))
        ;; Mark form as dirty
        (assoc-in [:form-states2 steps-form-id :dirty?] true))))

(re-frame/reg-event-db
  ::reset-form-state
  (fn [db]
    (assoc-in db [:form-states2 steps-form-id] {})))

(re-frame/reg-sub
  ::steps-params
  (fn [db _]
    (get-in db [:form-states2 steps-form-id :steps-params] {})))

;;; Internal sub-components

(defn- steps-generator-loader []
  [:div.smartfox-loading-container
   [spinners/mux-spinner
    {:size :medium}]
   [:div
    (get-translation "test.smartfox.loading-string" "Please wait .... Generating Steps")]])

(defn- step-markdown-editor
  [step-id field-id can-edit? new?]
  (let [loading-ref (reagent/atom nil)
        field-state @(re-frame/subscribe [::step-field-state step-id])
        attachments @(re-frame/subscribe [::step-attachments step-id])
        {:keys [max-attachments max-attachment-size]} @(re-frame/subscribe [::subs/options])
        current-text (get-in field-state [:fields field-id :value])
        users @(re-frame/subscribe [::subs/users])
        {:keys [ai-loading? ai-enhanced-text footer-content]}
        (ai-text-enhancement/get-ai-enhancement-state steps-form-id step-id field-id current-text can-edit? loading-ref)]

    ;; Scroll to loading state when it becomes active
    (when ai-loading?
      (reagent/after-render
       (fn []
         (when-let [loading-element @loading-ref]
           (.scrollIntoView loading-element #js {:behavior "smooth" :block "center"})))))

    [markdown3/markdown-editor
     (cond->
      {:value      (get-in field-state [:fields field-id :value])
       :autosize?  true
       :min-height 60
       :read-only? (not can-edit?)
       :preview-class :memo
       :on-change  (fn [value]
                     (re-frame/dispatch-sync [::change-step-field-value step-id field-id value]))
       :params @(re-frame/subscribe [::steps-params])
       :users users
       :on-add-param (fn [new-param-name]
                       (mixpanel/track "Create new Parameter")
                       (re-frame/dispatch
                        [::tests-events/create-step-param new-param-name]))
       :fullscreen-backdrop? true
       :external-fullscreen? (or ai-loading? (some? ai-enhanced-text))
       :on-fullscreen-exit (fn []
                              ;; Exit fullscreen clears AI enhancement state completely
                             (re-frame/dispatch [::ai-text-enhancement/exit-enhancement-fullscreen steps-form-id step-id field-id]))
       :footer-content footer-content}

       ;; Drag/drop handlers - work for both new and saved steps
       true (assoc
             :on-drag-over (fn [e] (on-drag-over-attachments e))
             :on-drag-leave (fn [e]
                              (.preventDefault e)
                              (.stopPropagation e))
             :on-drop (fn [e]
                        (on-drop-attachments e step-id :test-step
                                             (if new?
                                               [::attachment-staged-from-markdown
                                                {:stage-path [:form-states2 steps-form-id :steps step-id :attachments :stage]
                                                 :field-path [:form-states2 steps-form-id :steps step-id :fields field-id]}
                                                nil]
                                               [::step-attachment-uploaded-from-markdown step-id field-id nil])
                                             [::step-attachment-uploaded-failed-from-markdown step-id field-id nil]
                                             new?)))
       ;; on-load-file (paste) - uses staging for new steps, regular upload for saved steps
       true (assoc
                   :on-load-file (fn [file file-placeholder]
                                   (on-load-attachments file
                                                        step-id
                                                        :test-step
                                                        attachments
                                                        max-attachments
                                                        max-attachment-size
                                                        (if new?
                                                          [::attachment-staged-from-markdown
                                                           {:stage-path [:form-states2 steps-form-id :steps step-id :attachments :stage]
                                                            :field-path [:form-states2 steps-form-id :steps step-id :fields field-id]}
                                                           file-placeholder]
                                                          [::step-attachment-uploaded-from-markdown step-id
                                                           field-id file-placeholder])
                                                        [::step-attachment-uploaded-failed-from-markdown step-id
                                                         field-id file-placeholder]
                                                        [::step-attachment-renamed step-id]
                                                        [::step-attachment-deleted step-id]
                                                        new?))))]))


(defn- step-name-editor
  [step-id]
  (let [field-state @(re-frame/subscribe [::step-field-state step-id])]
    [:textarea
     {:placeholder (get-translation "test.steps.test-name-placeholder" "Enter Name")
      :aria-label  (get-translation "test.step.column-header-name" "Step Name")
      :class [:m-input :step-name-editor :m3-memo-]
      :value (get-in field-state [:fields :name :value])
      :on-change (fn [e]
                   (re-frame/dispatch-sync [::change-step-field-value step-id :name (dom/event-value e)]))}]))

(defn- attachments-section [can-edit? step-id new-step? attachments]
  (let [entity-type :test-step
        permissions {:can-upload? can-edit?
                     :can-preview? true
                     :can-download? true
                     :can-rename? (and can-edit? (not new-step?))
                     :can-delete? can-edit?
                     :can-copy-link? (not new-step?)}
        {:keys [max-attachments max-attachment-size]} @(re-frame/subscribe [::subs/options])
        options-atom (atom {:permissions permissions
                            :max-attachments max-attachments
                            :max-attachment-size max-attachment-size})
        event-options (if new-step?
                        {:entity-type entity-type
                         :step-id step-id
                         :uploaded-attachment-event [::step-attachment-staged step-id]}
                        {:entity-id step-id
                         :entity-type entity-type
                         :uploaded-attachment-event [::step-attachment-uploaded step-id]
                         :renamed-attachment-event [::step-attachment-renamed step-id]
                         :deleted-attachment-event [::step-attachment-deleted step-id]})]
    [:div.attachments-section
     [:span.text-nowrap.section-header
      (format-translation
        (get-translation "entity.tab.attachments" "Attachments (%{n})")
        :n (count @attachments))]
     [attachments/attachments-view
      {:options options-atom
       :attachments attachments
       :notifications (re-frame/subscribe [::attachments/notifications entity-type])
       :entity-type entity-type
       :show-search? false
       :install-paste-listener? false
       :actions (if new-step?
                  {:on-upload (fn [file]
                                (re-frame/dispatch [::attachments/stage-upload file event-options]))
                   :on-delete (fn [attachment]
                                (re-frame/dispatch [::step-attachment-stage-deleted step-id attachment]))
                   :on-clear-notifications #(re-frame/dispatch [::attachments/clear-notifications entity-type])
                   :on-cancel-uploads #(re-frame/dispatch [::attachments/cancel-uploads entity-type])}
                  {:on-upload (fn [file]
                                (re-frame/dispatch [::attachments/upload file event-options]))
                   :on-delete (fn [attachment]
                                (re-frame/dispatch [::attachments/delete attachment event-options]))
                   :on-rename (fn [attachment new-name]
                                (re-frame/dispatch [::attachments/rename attachment new-name event-options]))
                   :on-clear-notifications #(re-frame/dispatch [::attachments/clear-notifications entity-type])
                   :on-cancel-uploads #(re-frame/dispatch [::attachments/cancel-uploads entity-type])})}]]))

(defn- comments-section [entity-id step-id comments snapshot? new?]
  [:div.comments-section
   [:span.text-nowrap.section-header
    (format-translation
      (get-translation "entity.tab.comments" "Comments (%{n})")
      :n (count @comments))]
   [comments/comments-view {:comments comments
                            :added-comment-event [::added-comment entity-id]
                            :updated-comment-event [::added-comment entity-id]
                            :deleted-comment-event [::added-comment entity-id]
                            :entity-id step-id
                            :snapshot? snapshot?
                            :new? new?
                            :entity-type :test-step}]])

(defn- drag-handle [drag-listeners can-edit? snapshot?]
  [tooltip/mux-tooltip
   {}
   (get-translation "test.steps.drag-handle-tooltip" "Drag to reorder steps")
   (fn [props]
     [:span.test-step-drag-handle
      (merge props (when-not snapshot? drag-listeners)
                  ;; Keep drag handle there but make it invisble in case of no permissions
             {:class (dom/classes-pairs-v :invisible (not can-edit?))})
      (when-not snapshot? [icons/mux-drag-handle2])])])

(defn- remove-step-button
  [can-edit? step-form-state]
  [buttons/icon-button
   {:icon [icons/mux-trash]
    :disabled? (not can-edit?)
    :tooltip "Remove Step"
    :class [:me-auto]
    :on-click (fn [e]
                (re-frame/dispatch [::remove-step step-form-state]))}])

(defn- call-to-test-component
  [{:keys [can-edit? snapshot? drag-listeners] :as props} idx step-form-state]
  (let [entity @(re-frame/subscribe [::subs/entity :test])
        test (:current entity)]
    [:div.test-step-fields.call-to-test
     [:div.selector-column
      [drag-handle drag-listeners can-edit? snapshot?]
      (str idx)]
     [:div.test-step-name
      "Call a Test"]
     [:div.call-to-test-description
      [:a {:href (broutes/get-url-view "qtest_designs#edit" {:id (:id (:callee-test step-form-state))})
           :target "_BLANK"}
       (call-to-test/format-ctt-name (:callee-test step-form-state) test)]]
     [:div.control-buttons
      (when-not snapshot?
        [remove-step-button can-edit? step-form-state])]]))

(defn- simple-step-component
  [{:keys [toggle! expanded? can-edit? snapshot? drag-listeners entity-id] :as props} idx step-form-state]
  (let [step-id (:id step-form-state)
        ;; Need new backend method to support comments and attachments on new steps
        new? (:new? step-form-state)
        comments (re-frame/subscribe [::step-comments step-id])
        attachments (re-frame/subscribe [::step-attachments step-id])
        can-edit? (and can-edit? (not snapshot?))]
    [:<>
     [:div.test-step-fields
      [:div.selector-column
       [drag-handle drag-listeners can-edit? snapshot?]
       (str idx)
       (when (:smartfox-step? step-form-state)
         [:span.smartfox-step-indicator
          [icons/mux-smart-fox2]])]
      [:div.test-step-name
       (if can-edit?
         [step-name-editor step-id]
         (get-in step-form-state [:fields :name :value]))]
      [:div.description
       [step-markdown-editor step-id :description can-edit? new?]]
      [:div.expected-results
       [step-markdown-editor step-id :expected_results can-edit? new?]]
      [:div.control-buttons
       (when-not snapshot?
         [remove-step-button can-edit? step-form-state])
       [:div.counter-pill-holder
        (when (> (count @attachments) 0)
          [:div.counter-pill (str (count @attachments))])
        [buttons/icon-button
         {:icon [icons/mux-paperclip]
          :on-click toggle!
          :tooltip (get-translation "test.steps.attachments-tooltip"
                                    "Step Attachments")}]]
       [:div.counter-pill-holder
        (when (> (count @comments) 0)
          [:div.counter-pill (str (count @comments))])
        [buttons/icon-button
         {:icon [icons/mux-comments]
          :disabled? new?
          :on-click toggle!
          :tooltip (if new?
                     (get-translation "test.steps.comments-disabled-tooltip"
                                      "Comments are disabled for not saved steps for now")
                     (get-translation "test.steps.comments-tooltip"
                                      "Step Comments"))}]]
       [buttons/icon-button
        {:icon (if @expanded?
                 [icons/mux-chevron-up2]
                 [icons/mux-chevron-down2])
         :disabled? new?
         :on-click toggle!
         :tooltip (if new?
                    (get-translation "test.steps.comments-attachments-disabled-tooltip"
                                     "Comments and attachments are disabled for not saved steps for now")
                    (get-translation "test.steps.comments-attachments-tooltip"
                                     "Show comments and attachments for step"))}]]]
     (when @expanded?
       [:div.attachments-comments-section
        [comments-section entity-id step-id comments snapshot? new?]
        [attachments-section can-edit? step-id new? attachments]])]))

(defn- unknown-step-type
  [step-type]
  [:pre "Unknown step type: " (if (nil? step-type)
                                "nil"
                                (str step-type))])

(defn- step-container-component
  [{:keys [toggle! expanded? can-edit? drag-listeners entity-id] :as props} idx step-form-state]
  (case (:type step-form-state)
    :step [simple-step-component props idx step-form-state]
    :call-to-test [call-to-test-component props idx step-form-state]
    ;; else
    [unknown-step-type (:type step-form-state)]))

(defn- add-step-button
  [_]
  (let [add-step-expanded? (reagent/atom false)
        hide-add-step! (fn []
                         (reset! add-step-expanded? false))
        toggle-add-step! (fn []
                           (swap! add-step-expanded? not))]
    (fn [{:keys [position can-edit? snapshot?]}]
        [:div.add-step-menu-container
         [:span.add-step-pseudo-border]
         (when (not snapshot?)
           [overlay2/floating-ui-overlay
            {:on-request-close hide-add-step!
             :show? @add-step-expanded?
             :flip true
             :offset 0
             :placement "bottom"}
            [buttons/button
             {:tertiary? true
              :on-click toggle-add-step!
              :active? @add-step-expanded?
              :text (get-translation "test.steps.toolbar-add-step-label" "Add Step")
              :end-icon [icons/mux-chevron-down2]}]
            (let [menu-item-helper
                  (fn [text icon dispatch]
                    [dropdown/dropdown-menu-item
                     {:text text
                      :on-click (fn []
                                  (hide-add-step!)
                                  (re-frame/dispatch dispatch))
                      :icon [icon]
                      :disabled? (not can-edit?)}])]
              [dropdown/dropdown-menu-body {}
               (menu-item-helper (get-translation "test.steps.toolbar-add-step-label" "Add Step")
                                 icons/mux-plus-circle
                                 [::add-empty-step position])
               (menu-item-helper (get-translation "test.steps.toolbar-call-a-test-label" "Call a Test")
                                 icons/mux-folders
                                 [::call-to-test/show-call-to-test position])
               (menu-item-helper (get-translation "test.steps.toolbar-copy-step-label" "Copy Step")
                                 icons/mux-copy2
                                 [::copy-steps/show-copy-steps position])])])
         [:span.add-step-pseudo-border]])))

(defn- step-component-f []
  ;; TODO: re-frame state for external control ?
  (let [expanded? (reagent/atom false)
        toggle! (fn []
                  (swap! expanded? not))]
    (fn [form-props idx step-form-state]
      ;; We have a bit peculiar setup here - in order to correctly show dragged test step we need
      ;; to duplicate our grid layout from parent container
      ;; But we want to keep it consistent with parent container grid
      (let [step-id (:id step-form-state)
            {:keys [setNodeRef listeners active transition transform]} (dndkit/use-sortable step-id {})
            dragged-step? (= (:id active) step-id)
            test (:base-entity form-props)
            new? (:new? form-props)
            snapshot? (and test (false? (:current test)))
            edit-locked? (:edit_locked (:base-entity form-props))
            edit-permissions? (:edit-permissions? form-props)
            can-edit? (and edit-permissions? (not edit-locked?))]
        [:div.test-step-container
         {:ref setNodeRef
          :class (dom/classes-pairs-v :first-container (= idx 1))
          :key step-id
          ;; TODO: use node ref that is stored in dndContext ?
          :data-step-id (str step-id)
          :style {:position (if dragged-step?
                              ;; To create new stacking context - otherwise dragged element appears "below" next containers
                              "relative"
                              "static")
                  :z-index (if dragged-step?
                             ;; Same as above
                             10
                             0)
                  :transition transition
                  :transform (dndkit/build-transform-string transform)}}
         [step-container-component
          {:toggle! toggle!
           :expanded? expanded?
           :entity-id (:entity-id form-props)
           :can-edit? can-edit?
           :snapshot? snapshot?
           :drag-listeners listeners}
          idx step-form-state]
         [add-step-button {:position (:position step-form-state)
                           :can-edit? can-edit?
                           :snapshot? snapshot?}]]))))

(defn- precondition-step-item
  [can-edit? entity-id]
  (let [loading-ref (reagent/atom nil)
        new-precondition? @(re-frame/subscribe [::new-precondition?])
        attachments @(re-frame/subscribe [::attachments/attachments :test entity-id])
        {:keys [max-attachments max-attachment-size]} @(re-frame/subscribe [::subs/options])
        step-id :preconditions
        field-id :preconditions
        field-state @(re-frame/subscribe [::f3.forms/field-state steps-form-id :preconditions])
        current-text (:value field-state)
        users @(re-frame/subscribe [::subs/users])
        {:keys [ai-loading? ai-enhanced-text footer-content]}
        (ai-text-enhancement/get-ai-enhancement-state steps-form-id step-id field-id current-text can-edit? loading-ref)]

    ;; Scroll to loading state when it becomes active
    (when ai-loading?
      (reagent/after-render
       (fn []
         (when-let [loading-element @loading-ref]
           (.scrollIntoView loading-element #js {:behavior "smooth" :block "center"})))))
    [:div.test-step-container.precondition-step-item
     {:class (dom/classes-pairs-v "new-precondition" new-precondition?)}
     [:div.test-step-fields.precondition
      [:div.selector-column]
      [:div.test-step-name (get-translation "test.step.preconditions-label" "Precondition")]
      [:div.precondition-description
       [markdown3/markdown-editor
        (cond->
         {:editing? true
          :autosize? true
          :read-only? (not can-edit?)
          :id :preconditions
          :value (:value field-state)
          :placeholder (get-translation "test.step.preconditions-placeholder" "Precondition")
          :preview-class :memo
          :users users
          :on-change (fn [value]
                       (re-frame/dispatch-sync [::f3.forms/set-field-state steps-form-id :preconditions
                                                {:value value
                                                 :dirty? true}]))
          :fullscreen-backdrop? true
          :external-fullscreen? (or ai-loading? (some? ai-enhanced-text))
          :on-fullscreen-exit (fn []
                                 ;; Exit fullscreen clears AI enhancement state completely
                                (re-frame/dispatch [::ai-text-enhancement/exit-enhancement-fullscreen steps-form-id step-id field-id]))
          :on-drag-over (fn [e]
                          (on-drag-over-attachments e))
          :on-drag-leave (fn [e]
                           (.preventDefault e)
                           (.stopPropagation e))
          :on-drop (fn [e]
                     (on-drop-attachments e entity-id (if new-precondition? :test-precondition :test)
                                          (if new-precondition?
                                            [::attachment-staged-from-markdown
                                             {:stage-path [:form-states2 steps-form-id :precondition-stage-attachments]
                                              :field-path [:form-states2 steps-form-id :fields :preconditions]}
                                             nil]
                                            [::precondition-attachment-uploaded-from-markdown nil])
                                          [::precondition-attachment-upload-failed-from-markdown nil]
                                          new-precondition?))
          :on-load-file (fn [file file-placeholder]
                          (on-load-attachments file
                                               entity-id
                                               (if new-precondition? :test-precondition :test)
                                               attachments
                                               max-attachments
                                               max-attachment-size
                                               (if new-precondition?
                                                 [::attachment-staged-from-markdown
                                                  {:stage-path [:form-states2 steps-form-id :precondition-stage-attachments]
                                                   :field-path [:form-states2 steps-form-id :fields :preconditions]}
                                                  file-placeholder]
                                                 [::precondition-attachment-uploaded-from-markdown file-placeholder])
                                               [::precondition-attachment-upload-failed-from-markdown file-placeholder]
                                               [::attachments/renamed]
                                               [::attachments/deleted]
                                               new-precondition?))
          :footer-content footer-content})]]
      [:div.control-buttons
       [buttons/icon-button
        {:icon [icons/mux-trash]
         :tooltip (get-translation "test.step.preconditions-remove-tooltip" "Remove Precondition")
         :disabled? (not can-edit?)
         :class [:me-auto]
         :on-click (fn [e]
                     (re-frame/dispatch [::remove-preconditions]))}]]]]))

(defn- test-steps-container
  []
  (let [active-id (reagent/atom nil)]
    (fn [form-props]
      [:div.test-steps-container
       [:div.test-step-container.container-header
        [:div.container-header-label (get-translation "test.step.column-header-number" "Step #")]
        [:div.container-header-label (get-translation "test.step.column-header-name" "Step Name")]
        [:div.container-header-label (get-translation "test.step.column-header-description" "Description")]
        [:div.container-header-label (get-translation "test.step.column-header-expected-results" "Expected Results")]]
       (let [steps-form-state @(re-frame/subscribe [::forms/form-state steps-form-id])
             preconditions? @(re-frame/subscribe [::show-preconditions?])
             steps (sort-by :position (vals (:steps steps-form-state)))
             empty-steps? (not (seq steps))
             steps-ids-array (into-array (map :id steps))
             loading-steps? @(re-frame/subscribe [::subs/progress? ::smartfox-modal/generate-steps])
             test (:base-entity form-props)
             new? (:new? form-props)
             snapshot? (and test (false? (:current test)))
             edit-locked? (:edit_locked (:base-entity form-props))
             edit-permissions? (:edit-permissions? form-props)
             can-edit? (and edit-permissions? (not edit-locked?) (not snapshot?))]
         [:div.test-steps-scrollable-parent
          (cond
            loading-steps?
            [steps-generator-loader]

            (and (not preconditions?)
                 empty-steps?)
            [:div.test-steps-empty-label (get-translation "test.steps.empty-steps-message"
                                                          "No Steps Defined. Please add steps to your test")]
            :else
            [:div.test-steps-scrollable-container
             [dndkit/dnd-context
              {:on-drag-end (fn [e]
                              (reset! active-id nil)
                              (let [active-id (some-> e .-active .-id)
                                    over-id (some-> e .-over .-id)]
                                (when-not (= active-id over-id)
                                  (let [new-vector (oldsettings/vector-move
                                                     (vec steps)
                                                     (.indexOf steps-ids-array active-id)
                                                     (.indexOf steps-ids-array over-id))
                                        new-steps (map-indexed
                                                    (fn [idx item]
                                                      (assoc item :position (inc idx)))
                                                    new-vector)]
                                    (re-frame/dispatch [::reorder-steps new-steps])))))
               :on-drag-start (fn [e]
                                (reset! active-id (some-> e .-active .-id)))}
              [dndkit/sortable-context
               {:items steps-ids-array
                :strategy dndkit/verticalListSortingStrategy}
               (into [:<>
                      (when preconditions?
                        [precondition-step-item can-edit? (:entity-id form-props)])]
                     (map
                       (fn [step]
                         [:f> step-component-f form-props (:position step) step]))
                     steps)]]])])])))

;;; External components

(defn steps-tab
  [form-props]
  (let [edit-permissions? (:edit-permissions? form-props)
        edit-locked? (:edit_locked (:base-entity form-props))
        can-edit? (and edit-permissions? (not edit-locked?))
        test (:base-entity form-props)
        new? (:new? form-props)
        snapshot? (and test (false? (:current test)))
        preconditions? @(re-frame/subscribe [::show-preconditions?])
        is-preconditions-linked-to-test? @(re-frame/subscribe [::is-preconditions-linked-to-test?])
        loading? @(re-frame/subscribe [::subs/progress? ::fetch-test-steps])
        add-precondition-disabled? (or (not can-edit?)
                                       (not is-preconditions-linked-to-test?)
                                       preconditions?)
        ;; Reusing grid subscriptions here
        on-expand-click (partial-dispatch [::common-events/toggle-expanded :test :test-steps])
        expanded? @(re-frame/subscribe [::grid.subs/expanded? :test :test-steps])]
    [:div.test-steps-tab-body
     ; Previously it worked a little differently. When pressing the hotkey it went to the "Steps" tab and then added an empty step. 
     ; Now it works only if the "Steps" tab is enabled
     [keyboard-shortcuts/add-shortcut {:shortcut [:entity-form :add-test-step] 
                                       :handler (fn [] (re-frame/dispatch [::add-empty-step]))}]
     [copy-steps/copy-step-modal form-props]
     [call-to-test/call-to-test-modal form-props]
     [smartfox-modal/smartfox-modal form-props]
     [:div.steps-header-buttons
      [grid2/expand-button {:expanded? expanded?
                            :class [:expand-button]
                            :on-expand-click on-expand-click}]
      (when-not snapshot?
        [:div.test-steps-toolbar
         [smartfox-modal/smartfox-toolbar-button form-props]
         [buttons/button
        {:text (get-translation "test.steps.toolbar-import-steps-label" "Import Steps")
         :title (get-translation "test.steps.toolbar-import-steps-label" "Import Steps")
         :disabled? (not can-edit?)
         :href (when can-edit?
                 (broutes/get-url-view "import#new"
                                     {:project-id @(re-frame/subscribe [::subs/current-project-id])}
                                     {:entity_type "StepDesign"
                                      :import_from_test (:display_id test)}))
         :class "hide-text"
         :icon [icons/mux-upload]}]
       [buttons/button
        {:text (get-translation "test.steps.toolbar-copy-step-label" "Copy Step")
         :title (get-translation "test.steps.toolbar-copy-step-label" "Copy Step")
         :on-click #(re-frame/dispatch [::copy-steps/show-copy-steps])
         :disabled? (not can-edit?)
         :class "hide-text"
         :icon [icons/mux-copy2]}]
       [buttons/button
        {:text (get-translation "test.steps.toolbar-call-a-test-label" "Call a Test")
         :title (get-translation "test.steps.toolbar-call-a-test-label" "Call a Test")
         :on-click #(re-frame/dispatch [::call-to-test/show-call-to-test])
         :disabled? (not can-edit?)
         :class "hide-text"
         :icon [icons/mux-folders]}]
       (if add-precondition-disabled?
         [:span {:style {:display "inline-block"}
                 :title (when (not is-preconditions-linked-to-test?)
                          (get-translation "test.steps.toolbar-add-precondition-tooltip-disabled" "The Precondition feature has been disabled in Project Settings."))}
          [buttons/button
           {:text (get-translation "test.steps.toolbar-add-precondition-label" "Add Precondition")
            :title (get-translation "test.steps.toolbar-add-precondition-label" "Add Precondition")
            :disabled? true
            :class "hide-text"
            :icon [icons/mux-add-step]
            :on-click (fn [e]
                        (re-frame/dispatch [::add-preconditions]))}]]
         [buttons/button
          {:text (get-translation "test.steps.toolbar-add-precondition-label" "Add Precondition")
           :title (get-translation "test.steps.toolbar-add-precondition-label" "Add Precondition")
           :disabled? false
           :class "hide-text"
           :icon [icons/mux-add-step]
           :on-click (fn [e]
                       (re-frame/dispatch [::add-preconditions]))}])
       [buttons/button
        {:text (get-translation "test.steps.toolbar-add-step-label" "Add Step")
         :disabled? (not can-edit?)
         :icon [icons/mux-add-step]
         :on-click (fn [e]
                     (re-frame/dispatch [::add-empty-step]))}]])]
     [test-steps-container form-props]]))
     ;; Empty label


